
  <section class="modal-body text-center pl-5 pr-5 pb-5">
    <header class="modal-header bg-white border-bottom-0">
      <button type="button" class="close" (click)="onDismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </header>
    <footer class="row">
      <div class="col-12 mb-5">
        <strong>
          {{ encuestaModel.preguntas[currentStep].titulo }}
        </strong>
      </div>
      <div class="col-12" *ngIf="encuestaModel.preguntas[currentStep].tipo_Pregunta_Id == tipoPreguntaAbierta">
        <textarea cols="30" 
                  style="resize: none;"
                  rows="8" 
                  name="message"
                  [value]="preguntaAbiertaModel"
                  class="form-control"
                  (change)="textAreaToModel($event.target.value)"
                  (input)="textAreaToModel($event.target.value)"
                  >
        </textarea>
      </div>
      <div class="col-12" *ngIf="encuestaModel.preguntas[currentStep].tipo_Pregunta_Id == tipoPreguntaCheck">
        <div [class]="(encuestaModel.preguntas[currentStep].posibles_Respuestas.length <= 3)?'row row-cols-3': 'row row-cols-'+encuestaModel.preguntas[currentStep].posibles_Respuestas.length.toString()">
          <div class="col" 
            *ngFor="let posibles_Respuestas of encuestaModel.preguntas[currentStep].posibles_Respuestas; let i = index">
            <input type="radio" 
                   [id]="'posibles_Respuestas'+i" 
                   [name]="'posibles_Respuestas'+i"
                   [(ngModel)]="encuestaModel.preguntas[currentStep].valor"
                   value="{{posibles_Respuestas.id}}">
            <label for="'posibles_Respuestas'+i" class="m-2">{{posibles_Respuestas.label}}</label>
          </div>
        </div>
      </div>
      <div class="col-12" *ngIf="encuestaModel.preguntas[currentStep].tipo_Pregunta_Id == tipoPreguntaEmoji">
          <div [class]="(encuestaModel.preguntas[currentStep].posibles_Respuestas.length <= 3)?'row row-cols-3': 'row row-cols-'+encuestaModel.preguntas[currentStep].posibles_Respuestas.length.toString()">
            <div class="col" *ngFor="let posibles_Respuestas of encuestaModel.preguntas[currentStep].posibles_Respuestas; let i = index">
              <label>
                <input type="radio" 
                      [id]="'posibles_Respuestas'+i" 
                      [name]="'posibles_Respuestas'+i"
                      class="card-input-element"
                      value="{{posibles_Respuestas.id}}"
                      [(ngModel)]="encuestaModel.preguntas[currentStep].valor" />
      
                  <div class="panel panel-default card-input p-5">
                    <div class="panel-heading">
                      <mat-icon [style]="'-webkit-text-fill-color:'+posibles_Respuestas.emoji_Color+';font-size: 50px;margin-left: -50%;'">
                        {{posibles_Respuestas.emoji}}
                      </mat-icon>
                    </div>
                    <div class="panel-body">
                      {{posibles_Respuestas.label}}
                    </div>
                  </div>
              </label>
            </div>
          </div>
      </div>
      <div class="col-12" *ngIf="encuestaModel.preguntas[currentStep].tipo_Pregunta_Id == tipoPreguntaSeleccionMultiple">
        <div class="row" >
          <div class="col-12" >
            <mat-select
                class="form-control form-control-sm" 
                id="subcategorias_ids" 
                multiple 
                [(ngModel)]="encuestaModel.preguntas[currentStep].valor"
                disableOptionCentering>
                <mat-option *ngFor="let posibles_Respuestas of encuestaModel.preguntas[currentStep].posibles_Respuestas; let i = index" id="i" [value]="posibles_Respuestas?.id">
                  {{posibles_Respuestas?.label}}
                </mat-option>
            
            </mat-select>
          </div>
        </div>
      </div>
      <div class="col-12 row d-flex justify-content-end mt-5">
        <button 
          class="btn w-25 btn-outline-primary mr-3"
          *ngIf="currentStep > 0"
          (click)="stepSwitch('-')">Anterior</button>
        <button 
          class="btn w-25 btn-primary" 
          *ngIf="currentStep+1 != encuestaModel.
          preguntas.length"
          [disabled]="encuestaModel.preguntas[currentStep].valor == null || encuestaModel.preguntas[currentStep].valor == []"
          (click)="stepSwitch('+')">Siguiente</button>
        <button
          class="btn w-25 btn-primary"
          [disabled]="encuestaModel.preguntas[currentStep].valor == null || encuestaModel.preguntas[currentStep].valor == []"
          *ngIf="currentStep+1 == encuestaModel.
          preguntas.length"
          (click)="confirm()">Finalizar
          <!--
            enabled="encuestaModel.preguntas.every(i => i.valor != null)"-->
        </button>
      </div>
    </footer>
  </section>
  